import React from 'react'
import { Card, Button, Col, Row } from 'react-bootstrap'
import {useNavigate} from 'react-router-dom';
import useKrpanoJs from '../../hooks/useKrpanoJs'


const KrpanoPlayerJP = (props) => {
    const navigate = useNavigate();
    // window.removepano('krpanoSWFObject')
    const {containerRef} = useKrpanoJs()
	
  return (
    <>
    <Card className='no-border rounded-0'>
      <Row>
        <Col xs={{span:2, offset:10}} className="cross-button-home">
        <Row className='video-player-button'>
						<Col xs={{span:2, offset:3}}></Col>
						<Col xs={{span:2, offset:0}} className="text-center">
							<Button onClick={() => navigate('/jp/digital-twins', {replace: true})} className="product-modal-close-button"><img className='popup-modal-close-icon' src={"/assets/icons/close-icon.png"}  alt="close" /></Button>
						</Col>
						<Col xs={{span:2, offset:3}}></Col>
					</Row>
          
        </Col>
        <Col xs={{span:12, offset:0}}>
           <div ref={containerRef} className="container" />
        </Col>
      </Row>
    </Card>
      
    </>
  )
}

export default KrpanoPlayerJP
